import React from 'react';

export default () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33 36C33 38.2091 34.7909 40 37 40L83 40C85.2091 40 87 38.2091 87 36C87 33.7909 85.2091 32 83 32L37 32C34.7909 32 33 33.7909 33 36ZM37 72C34.7909 72 33 70.2091 33 68V52C33 49.7909 34.7909 48 37 48L83 48C85.2091 48 87 49.7909 87 52V68C87 70.2091 85.2091 72 83 72L37 72ZM37 87.9995C34.7909 87.9995 33 86.2087 33 83.9995C33 81.7904 34.7909 79.9995 37 79.9995L83 79.9995C85.2091 79.9995 87 81.7904 87 83.9995C87 86.2086 85.2091 87.9995 83 87.9995L37 87.9995Z"
        fill="#F4F4F4"
      />
    </svg>
  );
};
